import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  ArrowSymbol,
  BannerWrapper,
  Button,
  DropdownButton,
  DropdownItem,
  DropdownSeasonsList,
  DynamicColumnsWrapper,
  GradientBG,
  ParentWrapper,
  ProgramBackground,
  ProgramMainMenu,
  ProgramNavVideos,
  ProgramPageWrapper,
  StyledDropdown,
  TaboolaColumn,
  TabsLinkIte,
  TabsNavItem,
} from './ProgramItem.style'
import { useOttOverlay } from '../../../contexts'
import {
  ILightRailItem,
  ISeriesTypeId,
  IShortVideoItem,
  ITabItem,
  railItemToLight,
} from '../../../types'
import { MainProgramMenu } from '../MainProgramMenu/MainProgramMenu'
import { fetchSeasons, fetchSimilarPrograms } from '../API/API'
import { ProgramSeries } from './ProgramSeries'
import { useProgramContext } from './ProgramContext'
import { IOttSeason } from '../../types'
import { he } from '../../../locales/he'
import { useRootStore } from '../../../store'
import { ottRoot } from '../../Api'
import { mediaCdn, utils } from '../../../components/Player/Helpers'
import { clientConfig } from '../../../client'
import { OttTaboolaProgramItemWidget } from '../../AdsComponents'
import { BreadCrumbs, ICrumb } from '../BreadCrumbs/BreadCrumbs'
import Link from '../../../components/Link/Link'
import { ShortVideos } from './ShortVideos'
import { useRouter } from 'next/router'
import { getParameterByName, prettyLog } from '../../../utils'
import { useOttStore } from '../../store/ottStore'
import dynamic from 'next/dynamic'

const TopBanner = dynamic(
  () => import('../../../components/Ads/TopBanner/TopBanner'),
  { ssr: false }
)

export const ProgramItem = () => {
  const { asPath } = useRouter()
  const { ks, programData } = useOttOverlay()
  // const { pageTitle } = useRootStore()
  const taboolaCounter = useRef(0)
  const taboolaLeftRailCounter = useRef(0)
  const { program, episode, setEpisode, seasonNumber, setSeasonNumber } =
    useProgramContext()

  const [seasonsEpisodes, setSeasonsEpisodes] = useState<ILightRailItem[]>(
    programData?.episodes || ([] as ILightRailItem[])
  )
  const [seasonsSimilarEpisodes, setSeasonsSimilarEpisodes] = useState<
    ILightRailItem[]
  >([] as ILightRailItem[])
  useEffect(() => {
    setSeasonsEpisodes(programData?.episodes || ([] as ILightRailItem[]))
  }, [programData?.episodes])

  useEffect(() => {
    const tperitem = parseInt(getParameterByName('lrc')) || 7
    taboolaLeftRailCounter.current = Math.ceil(
      seasonsEpisodes.length / tperitem
    )
  }, [seasonsEpisodes.length])

  const pageImage = useMemo(() => {
    const defaultImg = `${mediaCdn}q_auto:best/v1750236296/assets/2025/default.webp`
    if (programData && programData.programData) {
      return (
        programData.programData?.images?.find(
          (img: { imageTypeName?: string }) => img?.imageTypeName === '16x9'
        )?.url || defaultImg
      )
    }
    return defaultImg
  }, [programData])
  const [nowPlaying, setNowPlaying] = useState<ILightRailItem | null>(null)
  const [selectedNav, setSelectedNav] = useState<
    'season' | 'similar' | 'short' | 'timeline' | 'site' | 'string'
  >('season')
  const [seriesIdType, setSeriesIdType] = useState<ISeriesTypeId | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const dropdownButtonRef = useRef<HTMLDivElement | null>(null)
  const [seasons, setSeasons] = useState([] as IOttSeason[])
  const [seasonTagName, setSeasonTagName] = useState(
    programData?.season?.name || ''
  )
  const { setSkipMaavaron, setPageTitle } = useRootStore()
  const { shortVideos, setShortVideos } = useOttStore()
  const [tabs, setTabs] = useState<ITabItem | null>(null)
  const [shortVideosTabTitle, setShortVideosTabTitle] = useState<string>('')

  const shortVideosPath = useMemo(
    () =>
      clientConfig.configFile?.short_videos_client ||
      '/cdn/short_clips_and_tabs/',
    []
  )

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      dropdownButtonRef.current &&
      !dropdownRef.current.contains(event.target as Node) &&
      !dropdownButtonRef.current.contains(event.target as Node)
    ) {
      const target = event.target as HTMLDivElement
      try {
        if (
          target &&
          target.className &&
          (target.className.includes(
            'ProgramItemstyle__DynamicColumnsWrapper'
          ) ||
            target.className.includes('ProgramItemstyle__DropdownItem'))
        ) {
          setTimeout(() => {
            setIsOpen(false)
          }, 100)
        }
      } catch (e) {
        prettyLog('ProgramItem: 128', { e }, 'error')
      }
    }
    // else {
    //   setIsOpen(false)
    // }
  }

  useEffect(() => {
    const fetchShortVideos = () => {
      if (shortVideosPath) {
        fetch(`${shortVideosPath}show_${program.id}.json`)
          .then(res => {
            if (!res.ok) {
              prettyLog('tabs', `Failed to fetch: ${res.status}`)
              throw new Error(`Failed to fetch: ${res.status}`)
            }
            return res.json()
          })
          .then(data => {
            setShortVideos(data.clips.posts as IShortVideoItem[])
            data.tabs && setTabs(data.tabs)
            setShortVideosTabTitle(data.clips.title || he.shortVideos)
          })
          .catch(err => {
            console.error(err)
            prettyLog('tabs', 'Failed set tabs')
          })
      }
    }
    fetchShortVideos()
    window.addEventListener('popstate', fetchShortVideos)
    return () => window.removeEventListener('popstate', fetchShortVideos)
  }, [program.id, setShortVideos, shortVideosPath])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    setSelectedNav('season')
  }, [program.id, episode])

  useEffect(() => {
    // setSkipMaavaron(true)
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [setSkipMaavaron])

  useMemo(() => {
    const getNowPlaying = () => {
      let current = null
      if (selectedNav && seasonsEpisodes && seasonsEpisodes.length > 0) {
        if (episode) {
          current = seasonsEpisodes.find(ep => ep.id === episode)
        }
        if (!current && !nowPlaying && !episode) {
          current = seasonsEpisodes[seasonsEpisodes.length - 1]
        }

        if (current) {
          return current
        } else if (
          selectedNav === 'season' &&
          seasonsEpisodes &&
          seasonsEpisodes.length > 1 &&
          !episode
        ) {
          current = seasonsEpisodes[0]
        }
      }
      return current || null
    }
    const ep = getNowPlaying()
    if (ep && ep.id !== nowPlaying?.id) {
      setPageTitle(ep.metas.ShortSummary || ep.name)
      setEpisode(ep.id)
      setNowPlaying(ep)
    }
  }, [
    episode,
    nowPlaying,
    seasonsEpisodes,
    selectedNav,
    setEpisode,
    setPageTitle,
  ])

  useMemo(() => {
    try {
      if (ks && program.id) {
        fetchSeasons(program.id, ks).then(response => {
          const { data } = response
          if (data?.result?.objects) {
            const seasonList = data.result.objects.map(
              (obj: {
                id: number
                metas: { SeasonNumber: { value: number } }
                tags: { SeasonName?: { objects: { value: string }[] } }
              }) => {
                const meta = obj.metas
                return {
                  id: obj.id,
                  name:
                    obj.tags.SeasonName?.objects[0].value ||
                    he.season + ' ' + meta.SeasonNumber.value,
                  position: meta.SeasonNumber.value,
                } as IOttSeason
              }
            )

            const [first] = data.result.objects
            setSeriesIdType({
              id: first.id,
              length: data.result.objects.length,
              type: first.type,
            })
            setSeasons(seasonList)
          }
        })
      }
    } catch (error) {
      console.error('Error fetching additional seasons:', error)
    }
  }, [ks, program.id])

  useEffect(() => {
    const currentSe = seasons.find(se => se.position === seasonNumber)
    currentSe && setSeasonTagName(currentSe.name)
  }, [seasonNumber, seasons])

  useEffect(() => {
    !seasonNumber && seasons.length > 0 && setSeasonNumber(seasons[0].position)
  }, [seasonNumber, seasons, setSeasonNumber])

  useEffect(() => {
    const fetchSimilarSeries = () => {
      try {
        fetchSimilarPrograms(seriesIdType, ks).then(response => {
          if (response?.data?.result?.objects) {
            setSeasonsSimilarEpisodes(
              utils.shuffle(response.data.result.objects.map(railItemToLight))
            )
          }
        })
      } catch (error) {
        console.error('Error fetching additional seasons:', error)
      }
    }
    fetchSimilarSeries()
  }, [ks, seriesIdType, program.id])

  const EpisodesList = useMemo(() => {
    if (
      (seasonsEpisodes.length > 0 && selectedNav == 'similar') ||
      selectedNav == 'season'
    ) {
      return (
        <ProgramSeries
          key={'ProgramSeries_' + program.id + '_' + seasonNumber}
          additionalSeries={
            selectedNav === 'season' ? seasonsEpisodes : seasonsSimilarEpisodes
          }
          taboolaCounter={taboolaCounter.current}
        />
      )
    }
    if (selectedNav === 'short') {
      return (
        <ShortVideos
          key={'ProgramSeries_' + program.id + '_' + seasonNumber}
          additionalSeries={shortVideos}
          taboolaCounter={taboolaCounter.current}
        />
      )
    }
    return null
  }, [
    seasonsEpisodes,
    selectedNav,
    program.id,
    seasonNumber,
    seasonsSimilarEpisodes,
    shortVideos,
  ])

  const SeasonsSelectorComp = useMemo(() => {
    return (
      <>
        <ProgramNavVideos>
          <StyledDropdown
            ref={dropdownRef}
            isOpen={isOpen}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
            key={['StyledDropdown', program.id, seasonNumber].join('_')}
          >
            <DropdownButton
              ref={dropdownButtonRef}
              isSelected={selectedNav === 'season'}
            >
              {seasonTagName || (seasonNumber && 'עונה ' + seasonNumber)}
            </DropdownButton>
            <ArrowSymbol
              isSelected={selectedNav === 'season'}
              theme={{ isOpen: isOpen }}
            >
              <img
                src={
                  'https://media3.reshet.tv/image/upload/v1707142246/drop_gwvp5f.svg'
                }
                alt={isOpen ? 'Open' : 'Closed'}
              />
            </ArrowSymbol>
          </StyledDropdown>
          <TabsNavItem
            onClick={() => {
              taboolaCounter.current += (seasonsEpisodes?.length || 0) + 1
              setSelectedNav('similar')
            }}
            theme={{
              isSelected: selectedNav === 'similar' ? 'primary' : 'secondary',
            }}
          >
            {he.similarShows}
          </TabsNavItem>
          {shortVideos && shortVideos.length > 0 && (
            <Button
              onClick={() => {
                taboolaCounter.current += (seasonsEpisodes?.length || 0) + 1
                setSelectedNav('short')
              }}
              isSelected={selectedNav === 'short'}
            >
              {shortVideosTabTitle}
            </Button>
          )}
          {tabs &&
            Object.values(tabs).map((tab, index) => {
              return (
                <TabsLinkIte key={index} href={tab.link} target={tab.target}>
                  {tab.title}
                </TabsLinkIte>
              )
            })}
        </ProgramNavVideos>
        <DropdownSeasonsList isOpen={isOpen} key={'DropdownList_' + program.id}>
          {seasons.map((season, index) => {
            const href = `${ottRoot}/series/${program.id}/season/${season.position}/`
            return (
              <Link key={index} href={href !== asPath ? href : ''}>
                <DropdownItem
                  key={program.id + '_' + season.position}
                  isSelected={season.position === seasonNumber}
                  onClick={() => {
                    setSelectedNav('season')
                    taboolaCounter.current += (seasonsEpisodes?.length || 0) + 1
                    // setSeasonNumber(season.position)
                  }}
                >
                  {season.name}
                </DropdownItem>
              </Link>
            )
          })}
        </DropdownSeasonsList>
      </>
    )
  }, [
    isOpen,
    program.id,
    seasonNumber,
    selectedNav,
    seasonTagName,
    shortVideos,
    shortVideosTabTitle,
    tabs,
    seasons,
    seasonsEpisodes?.length,
    asPath,
  ])

  const crumbList = useMemo(() => {
    const path = asPath.split('/').filter(p => !!p)
    const crumbs = [
      {
        name: `${program.name}`,
        link:
          path.length === 3
            ? ''
            : programData?.seriesHp ?? `${ottRoot}/series/${program.id}`,
      },
    ] as ICrumb[]

    if (path.length > 3) {
      crumbs.push({
        name: `${programData?.season.name}`,
        link:
          path.length === 5
            ? ''
            : `${ottRoot}/series/${program.id}/season/${seasonNumber}`,
      })
    }
    if (path.length > 5) {
      crumbs.push({ name: nowPlaying?.name || '' })
    }
    return crumbs
  }, [
    asPath,
    nowPlaying?.name,
    program.id,
    program.name,
    programData?.season?.name,
    programData?.seriesHp,
    seasonNumber,
  ])

  return (
    <>
      <BannerWrapper>
        <TopBanner key={'TopBanner'} isVod={true} />
      </BannerWrapper>
      <BreadCrumbs crumbList={crumbList} />
      <DynamicColumnsWrapper>
        <ProgramPageWrapper>
          <GradientBG />
          <ProgramMainMenu data-title={nowPlaying?.name}>
            {nowPlaying && pageImage && (
              <MainProgramMenu data={nowPlaying} key={nowPlaying.id} />
            )}
          </ProgramMainMenu>
          <ParentWrapper>{SeasonsSelectorComp}</ParentWrapper>
          {EpisodesList}
          <ProgramBackground programImage={pageImage} />
        </ProgramPageWrapper>
        <TaboolaColumn>
          <OttTaboolaProgramItemWidget
            counter={taboolaLeftRailCounter.current}
          />
        </TaboolaColumn>
      </DynamicColumnsWrapper>
    </>
  )
}
export default ProgramItem
